import { message } from '@whalecloud/fdx';
import { i18n } from 'fishx';

import {
  qryPortalList,
  qryDirMenus,
  delPortal,
  addPortal,
  updatePortal,
  delDirMenu,
  updateDirMenu,
  qryAllMenus,
  addDirMenuToPortal,
  qryDirMenuList,
} from '@pages/PortalMgr/services/PortalMgr';
import defaultSettings from '@config/defaultSettings';

const { themeConfig } = defaultSettings;
const themePrefix = themeConfig['@ant-prefix'];

const getBrotherRecord = (gridData, currentKey, direction) => {
  let brotherRow = '';
  const checkBrotherRecord = (gridDatas, currentKeys, directions) => {
    gridDatas.filter(item => {
      const { key } = item;
      if (key === currentKeys) {
        gridDatas.filter((itemB, index) => {
          if (itemB.key === currentKey) {
            if (directions === 'down') {
              if (index + 1 !== gridDatas.length) {
                brotherRow = gridDatas[index + 1];
              } else {
                brotherRow = 'none';
              }
            } else if (direction === 'up') {
              if (index + 1 !== 1) {
                brotherRow = gridDatas[index - 1];
              } else {
                brotherRow = 'none';
              }
            }
          }
          return itemB;
        });
      } else if (item.children) {
        checkBrotherRecord(item.children, currentKeys, directions);
      }
      return item;
    });
  };
  checkBrotherRecord(gridData, currentKey, direction);
  return brotherRow;
};

const handleMenuData = (menuData, isThird) => {
  const { data, newData } = menuData;
  data.filter(item => {
    if (item.parentId) {
      data.filter(itemA => {
        if ((isThird && item.parentId === itemA.partyId && itemA.parentId) || (!isThird && item.parentId === itemA.partyId && !itemA.parentId)) {
          const newItem = JSON.parse(JSON.stringify(item));
          newItem.key = `dirmenu-${itemA.partyId}-${item.partyId}`;
          newData.push(item);
          if (itemA.children) {
            itemA.children.push(newItem);
          } else {
            Object.assign(itemA, { children: [] });
            itemA.children.push(newItem);
          }
        }
        return itemA;
      });
    }
    return item;
  });
  return menuData;
};

const changeBrotherParams = (payload, brother) => [
  {
    partyId: payload.partyId,
    seq: brother.seq,
    oldSeq: payload.seq,
  },
  {
    partyId: brother.partyId,
    seq: payload.seq,
    oldSeq: brother.seq,
  },
];

const getTreeGridSearchRecord = (gridData, title, content) => {
  const searchRecord = [];
  const checkTreeGridSearchRecord = (gridDatas, titles, contents) => {
    gridDatas.filter(item => {
      if (item[titles] === contents) {
        searchRecord.push(item);
      } else if (item.children) {
        checkTreeGridSearchRecord(item.children, titles, contents);
      }
      return item;
    });
  };
  checkTreeGridSearchRecord(gridData, title, content);
  return searchRecord;
};

export default {
  namespace: 'PortalMgr',

  state: {
    dirMenusList: [],
    portalList: [],
    portal: [],
    dirMenuGridSelectedRowKey: 'dirmenu-1',
    portalGridSelectedRow: '',
    portalSelectedRecord: {},
    dirMenuSelectedRecord: {},
    menuBtnDisabled: true,
    dirMenuBtnDisabled: true,
    modalMenu: {
      title: '',
      menusList: [],
    },
    modalDirMenu: {
      title: '',
      dirMenusList: [],
    },
    modalMenuSelectRowKey: [],
    modalDirMenuSelectRowKey: [],
  },

  reducers: {
    fetch_dirMenus(state, { payload: data }) {
      return { ...state, dirMenusList: data };
    },
    fetch_portalList(state, { payload: data }) {
      return { ...state, portalList: data };
    },
    update_portal(state, { payload: data }) {
      return { ...state, portal: data };
    },
    update_portalRecord(state, { payload: data }) {
      return { ...state, portalSelectedRecord: data };
    },
    update_dirMenuKey(state, { payload: data }) {
      return { ...state, dirMenuGridSelectedRowKey: data };
    },
    update_dirMenuRecord(state, { payload: data }) {
      return { ...state, dirMenuSelectedRecord: data };
    },
    fetch_modalMenu(state, { payload: data }) {
      return { ...state, modalMenu: data };
    },
    fetch_modalDirMenu(state, { payload: data }) {
      return { ...state, modalDirMenu: data };
    },
    update_menuBtnDisabled(state, { payload: data }) {
      return { ...state, menuBtnDisabled: data };
    },
    update_dirMenuBtnDisabled(state, { payload: data }) {
      return { ...state, dirMenuBtnDisabled: data };
    },
    update_portalSelectRow(state, { payload: data }) {
      return { ...state, portalGridSelectedRow: data };
    },
    update_modalMenuSelectKey(state, { payload: data }) {
      return { ...state, modalMenuSelectRowKey: data };
    },
    update_modalDirMenuSelectKey(state, { payload: data }) {
      return { ...state, modalDirMenuSelectRowKey: data };
    },
    clearData(state, { payload }) {
      return {
        ...state,
        ...payload,
        dirMenusList: [],
        portalList: [],
        portal: [],
        dirMenuGridSelectedRowKey: 'dirmenu-1',
        portalGridSelectedRow: '',
        dirMenuSelectedRecord: {},
        menuBtnDisabled: true,
        dirMenuBtnDisabled: true,
        modalMenu: {
          title: '',
          menusList: [],
        },
        modalDirMenu: {
          title: '',
          dirMenusList: [],
        },
        modalMenuSelectRowKey: [],
        modalDirMenuSelectRowKey: [],
      };
    },
  },

  effects: {
    *fetchDirMenus({ payload }, { call, put, select }) {
      const { success, data } = yield call(qryDirMenus, payload);
      if (success) {
        const newData = [];

        data.filter((item, index) => {
          Object.assign(item, { key: `dirmenu-${(index + 2).toString()}` });
          return item;
        });

        let menuData = { data, newData };
        // 优先处理三级菜单
        menuData = handleMenuData(menuData, true);
        // 处理二级菜单或目录
        menuData = handleMenuData(menuData, false);

        const a = new Set(menuData.data);
        const b = new Set(menuData.newData);
        let getData = new Set([...a].filter(x => !b.has(x)));
        getData = [...getData];
        const topData = [
          {
            partyId: '0',
            partyName: 'Directory & Menu Management',
            key: 'dirmenu-1',
            seq: 0,
            state: 'A',
            portalId: payload,
            type: '0',
            keyId: '0',
            children: getData,
            expanded: true,
          },
        ];

        yield put({ type: 'fetch_dirMenus', payload: topData });
        yield put({ type: 'update_dirMenuKey', payload: 'dirmenu-1' });
        yield put({ type: 'update_dirMenuRecord', payload: topData[0] });
        let menuBtnDisabled = yield select(state => state.PortalMgr.menuBtnDisabled);
        let dirMenuBtnDisabled = yield select(state => state.PortalMgr.dirMenuBtnDisabled);
        if (topData[0].type === '0') {
          dirMenuBtnDisabled = false;
        }
        if (topData[0].partyId === '0') {
          menuBtnDisabled = false;
        }
        yield put({ type: 'update_menuBtnDisabled', payload: menuBtnDisabled });
        yield put({ type: 'update_dirMenuBtnDisabled', payload: dirMenuBtnDisabled });
        return topData;
      }
      yield put({
        type: 'clearData',
      });
      return null;
    },
    *fetchPortalList(_, { call, put }) {
      const { success, data } = yield call(qryPortalList);
      if (success) {
        data.filter(item => {
          Object.assign(item, { key: `${themePrefix}-list-${(item.portalId + 1).toString()}` });
          return item;
        });
        yield put({ type: 'fetch_portalList', payload: data });
        yield put({ type: 'update_portalSelectRow', payload: data[0] });
        yield put({ type: 'update_portalRecord', payload: data[0] });
        return data;
      }
      yield put({
        type: 'clearData',
      });
      return null;
    },
    *fetchPortalItem({ payload }, { select }) {
      const curPortalList = yield select(state => state.PortalMgr.portalList);
      return curPortalList.find(portalItem => {
        return portalItem.portalId === payload.portalId;
      });
    },
    *deletePortal({ payload }, { call }) {
      const { success, data } = yield call(delPortal, payload);
      if (success) return data;
      return null;
    },
    *addPortal({ payload }, { call, select }) {
      const gridData = yield select(state => state.PortalMgr.portalList);
      let msg = false;
      gridData.filter(item => {
        if (item.portalName === payload.portalName) {
          msg = true;
        }
        return item;
      });
      if (msg) {
        message.warn(i18n('PORTAL_ADD_SUCCESS'));
      } else {
        const { success, data } = yield call(addPortal, payload);
        if (success) return data;
        return null;
      }
      return null;
    },
    *updatePortalDetail({ payload }, { put }) {
      yield put({ type: 'update_portal', payload });
    },
    *updatePortal({ payload }, { call }) {
      const { success, data } = yield call(updatePortal, payload);
      if (success) return data;
      return null;
    },
    *updatePortalRecord({ payload }, { put }) {
      yield put({ type: 'update_portalRecord', payload });
    },
    *deleteDirMenu({ payload }, { call }) {
      const { success, data } = yield call(delDirMenu, payload.portalId, payload.partyId, payload.seq);
      if (success) return data;
      return null;
    },
    *changeDirMenuKey({ payload }, { put }) {
      yield put({ type: 'update_dirMenuKey', payload });
    },
    *downDirMenu({ payload }, { call, select }) {
      const gridData = yield select(state => state.PortalMgr.dirMenusList);
      const brother = getBrotherRecord(gridData, payload.key, 'down');
      if (brother !== 'none') {
        const portalDirMenuList = changeBrotherParams(payload, brother);
        yield call(updateDirMenu, payload.portalId, portalDirMenuList);
      }
      return brother;
    },
    *upDirMenu({ payload }, { call, select }) {
      const gridData = yield select(state => state.PortalMgr.dirMenusList);
      const brother = getBrotherRecord(gridData, payload.key, 'up');
      if (brother !== 'none') {
        const portalDirMenuList = changeBrotherParams(payload, brother);
        yield call(updateDirMenu, payload.portalId, portalDirMenuList);
      }
      return brother;
    },
    *updateDirMenuSelectRecord({ payload }, { put }) {
      yield put({ type: 'update_dirMenuRecord', payload });
      let dirMenuBtnDisabled = true;
      let menuBtnDisabled = true;
      if (payload.type === '0') {
        dirMenuBtnDisabled = false;
      }
      if (payload.partyId === '0') {
        menuBtnDisabled = false;
      }
      yield put({ type: 'update_menuBtnDisabled', payload: menuBtnDisabled });
      yield put({ type: 'update_dirMenuBtnDisabled', payload: dirMenuBtnDisabled });
    },
    *fetchMenus(_, { call, put, select }) {
      const { success, data } = yield call(qryAllMenus);
      if (success) {
        // 标题和列表
        const selectRecordData = yield select(state => state.PortalMgr.dirMenuSelectedRecord);
        const { children } = selectRecordData;
        const hasMenu = [];
        data.filter(item => {
          children.filter(itemA => {
            if (itemA.type === '1' && itemA.partyId === item.privId) {
              hasMenu.push(item);
            }
            return itemA;
          });
          return item;
        });
        const a = new Set(data);
        const b = new Set(hasMenu);
        let getData = new Set([...a].filter(x => !b.has(x)));
        getData = [...getData];
        getData.filter(item => {
          if (!item.key) {
            Object.assign(item, { key: item.privId.toString() });
          }
          return item;
        });
        const putData = {
          title: selectRecordData.partyName,
          menusList: getData,
        };
        yield put({ type: 'fetch_modalMenu', payload: putData });
        yield put({ type: 'update_modalMenuSelectKey', payload: [] });
      }
    },
    *addDirMenu({ payload }, { call, select }) {
      const selectRecordData = yield select(state => state.PortalMgr.dirMenuSelectedRecord);
      const menu = [];
      payload.filter(item => {
        const menuItem = {};
        menuItem.partyId = item.privId;
        menuItem.partyName = item.privName;
        menuItem.state = item.state;
        menuItem.type = 1;
        menuItem.url = item.url;
        menu.push(menuItem);
        return item;
      });
      const { success, data } = yield call(addDirMenuToPortal, selectRecordData.portalId, menu);
      if (success) return data;
      return null;
    },
    *refreshDirMenus(_, { select }) {
      const selectRecordData = yield select(state => state.PortalMgr.dirMenuSelectedRecord);
      return selectRecordData.portalId;
    },
    *fetchDirMenusList(_, { call, put, select }) {
      const selectRecordData = yield select(state => state.PortalMgr.dirMenuSelectedRecord);
      const { success, data } = yield call(qryDirMenuList, selectRecordData.partyId);
      if (success) {
        const dirMenuList = [];
        const getMenus = [];
        const { dirList, menuList } = data;
        // dirList
        if (dirList && dirList.length > 0) {
          dirList.filter(item => {
            Object.assign(item, {
              partyId: item.dirId,
              partyName: item.dirName,
              type: 0,
            });
            dirMenuList.push(item);
            return item;
          });
        }
        // menuList
        if (menuList && menuList.length > 0) {
          menuList.filter(item => {
            Object.assign(item, {
              partyId: item.menuId,
              partyName: item.privName,
              type: 1,
            });
            dirMenuList.push(item);
            return item;
          });
        }
        dirMenuList.filter(item => {
          if (
            !(
              selectRecordData.type === item.type &&
              (selectRecordData.partyId === item.partyId ||
                selectRecordData.dirId === item.partyId ||
                selectRecordData.menuId === item.partyId ||
                selectRecordData.privId === item.partyId)
            )
          ) {
            getMenus.push(item);
          }
          return item;
        });

        if (dirList && dirList.length > 0) {
          getMenus.filter(item => {
            if (!item.key) {
              Object.assign(item, { key: item.dirId ? item.dirId.toString() : `${item.partyId}__${item.menuId}` });
            }
            return item;
          });
        }
        if (menuList && menuList.length > 0) {
          getMenus.filter(item => {
            if (!item.key) {
              Object.assign(item, { key: item.menuId.toString() });
            }
            return item;
          });
        }
        const putData = {
          title: selectRecordData.partyName,
          dirMenusList: getMenus,
        };
        yield put({ type: 'fetch_modalDirMenu', payload: putData });
        yield put({ type: 'update_modalDirMenuSelectKey', payload: [] });
      }
    },
    *addDirMenuList({ payload }, { call, select }) {
      const selectRecordData = yield select(state => state.PortalMgr.dirMenuSelectedRecord);
      const parentId = selectRecordData.partyId;
      const menu = [];
      payload.filter(item => {
        const menuItem = {};
        menuItem.partyId = item.partyId;
        menuItem.partyName = item.partyName;
        menuItem.state = item.state;
        menuItem.type = item.type;
        menuItem.url = item.url ? item.url : '';
        if (parentId !== '0') {
          menuItem.parentId = parentId;
        }
        if (item.addCascade) {
          menuItem.addCascade = item.addCascade;
        }
        menu.push(menuItem);
        return item;
      });
      const { success, data } = yield call(addDirMenuToPortal, selectRecordData.portalId, menu);
      if (success) return data;
      return null;
    },
    *changePortalRow({ payload }, { put }) {
      yield put({ type: 'update_portalSelectRow', payload });
    },
    *dirMenuGridFilter({ payload }, { select, put }) {
      const gridData = yield select(state => state.PortalMgr.dirMenusList);
      const searchRecord = getTreeGridSearchRecord(gridData, payload.title, payload.content);
      if (searchRecord.length) {
        yield put({ type: 'update_dirMenuKey', payload: searchRecord[0].key });
      }
    },
    *modalMenuGridFilter({ payload }, { select, put }) {
      const gridData = yield select(state => state.PortalMgr.modalMenu.menusList);
      const searchRecord = gridData.filter(item => item[payload.title] === payload.content);
      if (searchRecord.length) {
        const key = [searchRecord[0].key];
        yield put({ type: 'update_modalMenuSelectKey', payload: key });
      }
    },
    *changeModalMenuKey({ payload }, { put }) {
      yield put({ type: 'update_modalMenuSelectKey', payload });
    },
    *modalDirMenuGridFilter({ payload }, { select, put }) {
      const gridData = yield select(state => state.PortalMgr.modalDirMenu.dirMenusList);
      const searchRecord = gridData.filter(item => item[payload.title] === payload.content);
      if (searchRecord.length) {
        const key = [searchRecord[0].key];
        yield put({ type: 'update_modalDirMenuSelectKey', payload: key });
      }
    },
    *changeModalDirMenuKey({ payload }, { put }) {
      yield put({ type: 'update_modalDirMenuSelectKey', payload });
    },
  },
};
